module.exports = __webpack_public_path__ + "img/Rookie-3.8c1c8417.png";